export default {
	data() {
		return {
			isMobile: window.innerWidth <= 560,
		};
	},

  	created() {
		window.addEventListener('resize', this.checkWindowSize);
	},

	beforeDestroy() {
		window.removeEventListener('resize', this.checkWindowSize);
	},

	methods: {
		checkWindowSize() {
			this.isMobile = window.innerWidth <= 560;
		}
	}
}